import { IntegrationActionTypes } from "./constants";
import { IntegrationStatus } from "./types";
import { WebhookLog } from "./types";

export const loadIntegrationStatus = (sellerId?: string) => ({
  type: IntegrationActionTypes.LOAD_INTEGRATION_STATUS,
  payload: { sellerId },
});

export const loadIntegrationStatusSuccess = (data: IntegrationStatus) => ({
  type: IntegrationActionTypes.LOAD_INTEGRATION_STATUS_SUCCESS,
  payload: { data },
});

export const loadIntegrationStatusError = (error: string) => ({
  type: IntegrationActionTypes.LOAD_INTEGRATION_STATUS_ERROR,
  payload: { error },
});

export const disconnectPlatform = (
  platform: string,
  options?: { sellerId?: string; integrationId?: string }
) => ({
  type: IntegrationActionTypes.DISCONNECT_PLATFORM,
  payload: {
    platform,
    sellerId: options?.sellerId,
    integrationId: options?.integrationId,
  },
});

export const disconnectPlatformSuccess = () => ({
  type: IntegrationActionTypes.DISCONNECT_PLATFORM_SUCCESS,
});

export const disconnectPlatformError = (error: string) => ({
  type: IntegrationActionTypes.DISCONNECT_PLATFORM_ERROR,
  payload: { error },
});

export const syncProducts = (
  platform: string,
  options?: { sellerId?: string; integrationId?: string }
) => ({
  type: IntegrationActionTypes.SYNC_PRODUCTS,
  payload: {
    platform,
    sellerId: options?.sellerId,
    integrationId: options?.integrationId,
  },
});

export const syncProductsSuccess = (platform: string, count?: number) => ({
  type: IntegrationActionTypes.SYNC_PRODUCTS_SUCCESS,
  payload: { platform, count },
});

export const syncProductsError = (error: string) => ({
  type: IntegrationActionTypes.SYNC_PRODUCTS_ERROR,
  payload: { error },
});

export const loadWebhookLogs = (
  params?: {
    skip?: number;
    limit?: number;
    platform?: string;
    status?: string;
    sellerId?: string;
  }
) => ({
  type: IntegrationActionTypes.LOAD_WEBHOOK_LOGS,
  payload: params || {},
});

export const loadWebhookLogsSuccess = (items: WebhookLog[], total: number) => ({
  type: IntegrationActionTypes.LOAD_WEBHOOK_LOGS_SUCCESS,
  payload: { items, total },
});

export const loadWebhookLogsError = (error: string) => ({
  type: IntegrationActionTypes.LOAD_WEBHOOK_LOGS_ERROR,
  payload: { error },
});
